<script>
import { mapActions, mapGetters } from 'vuex';
import { CUSTOMER_TYPES, CUSTOMER_SEX_TYPES, PAYMENT_TYPES } from '@/modules/constants';

export default {
  name: 'Coupon',
  components: {},
  data() {
    return {
      CUSTOMER_TYPES,
      CUSTOMER_SEX_TYPES,
      PAYMENT_TYPES,
      couponPost: false,
      couponCode: '',
      couponResponse: {
        'show': false,
        'type': '',
        'text': '',
      },
    };
  },
  computed: {
    ...mapGetters(['invoiceData', 'formData', 'prices', 'customer', 'validatedCouponData'])
  },
  methods: {
    ...mapActions([
      'setInvoiceDataAction',
      'updateFormDataAction',
      'updateInvoiceDataAction',
      'updateFormErrorAction',
      'setIsFormDetailsEditAction',
      'setIsMobileAction',
      'getTotalPriceAction',
      'postCouponAction'
    ]),
    couponCheck: function() {
      let couponCode = this.couponCode.trim();
      if (!this.couponPost && couponCode !== '') {
        this.$store.commit('SET_COUPON_CODE', couponCode);
        this.couponPost = true;
        this.postCouponAction(couponResponse => {
          this.couponPost = false;
          this.$store.commit('SET_VALIDATED_COUPON_DATA', couponResponse);
          this.getTotalPriceAction();
          if (couponResponse.success) {
            this.couponResponse.show = true;
            this.couponResponse.type = 'success';
            this.couponResponse.text = couponResponse.text;
          }else {
            this.couponResponse.show = true;
            this.couponResponse.type = 'danger';
            if (couponResponse.error) {
              this.couponResponse.text = couponResponse.error;
            }else {
              this.couponResponse.text = 'Ein Fehler ist aufgetreten!';
            }
          }
        });
      }
    },
    removeCoupon: async function() {
      this.couponPost = true;
      this.$store.commit('SET_COUPON_CODE', '');
      this.$store.commit('SET_VALIDATED_COUPON_DATA', {success: false});
      await this.getTotalPriceAction();

      this.couponCode = '';
      this.couponResponse = {
        'show': false,
        'type': '',
        'text': '',
      };
      this.couponPost = false;
    }
  },
  mounted() {}
};
</script>
<template>
  <div class="col-md-12 mt-3 pl-0 pr-0">
    <div
      class="step3-left panel panel-default panel-hv-grey p-0"
      style="box-shadow: none; border: 1px solid rgb(221,221,221);"
    >
      <div class="panel-body" style="min-height: 1px">
        <div class="mb-15">
          <strong> <i class="fa fa-money"></i> Gutschein: </strong>
        </div>
        <div class="row">
          <div class="col-md-12" v-if="couponResponse.show">
            <div :class="couponResponse.type ? 'alert alert-' + couponResponse.type : ''" role="alert">
              {{ couponResponse.text }}
            </div>
          </div>
          <div class="col-md-12">
            <div class="input-group" v-if="validatedCouponData && validatedCouponData.success === false">
              <input style="width: 100% !important;" v-model="couponCode" v-on:keyup.enter="couponCheck" type="text"
                     class="form-control" placeholder="Gutscheincode eingeben">
              <span class="input-group-btn">
                <button class="btn btn-primary" type="button" v-on:click="couponCheck" :disabled="couponPost">
                  <span v-show="!couponPost">Einlösen</span>
                  <span v-show="couponPost">Lädt <i class="fa fa-spinner"></i></span>
                </button>
              </span>
            </div>
            <div class="input-group" v-else-if="validatedCouponData && validatedCouponData.success === true">
              <input style="width: 100% !important;" type="text" :value="validatedCouponData.code" disabled="disabled" class="form-control" placeholder="Gutscheincode eingeben">
              <span class="input-group-btn">
                <button class="btn btn-primary" type="button" v-on:click="removeCoupon" :disabled="couponPost">
                  <span v-show="!couponPost">Entfernen</span>
                  <span v-show="couponPost">Lädt <i class="fa fa-spinner"></i></span>
                </button>
              </span>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import 'CouponStyles';
</style>
